import GlobalStyle from "./components/shared/GlobalStyles";
import { ThemeProvider } from "styled-components";
import { theme } from "./theme";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import { Privacy } from "./pages/Privacy";
import { Cookies } from "./pages/Cookies";
import { TermsAndConditions } from "./pages/TermsAndConditions";
import { Webinar } from "./pages/Webinar";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/webinar-bootcamp-frontend" element={<Webinar />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
